import React from "react";
import {
  ArhivaIndex
} from "../../_metronic/_partials";

export function ArhivaPage() {
  return <ArhivaIndex />;
}
